import EmptyTemplate from '../empty-result/empty-result.twig';
import NewsTemplate from '../../sections/news-list/templates/news-list.twig';
import {Utils} from '../../common/scripts/utils';

class Tags {
    constructor(options) {
        this.template = '';
        this.page = options.page;
        this.button = options.button;
        this.moreButton = options.moreButton || null;
        this.wrapper = options.listWrapper;
        this.itemClass = options.itemClass;
        this.contentWrapper = options.contentWrapper;
        this.activeClass = 'is-active';
        this.url = options.url;
        this.years = options.years || false;
        // В передаваемых опциях указать либо Array - для работы тегов аналогично чекбоксам, либо string - для работы как радиобаттоны
        this.method = options.method || 'string';
    }

    /**
     * Инициализация экземпляра класса
     * @public
     */
    init() {
        this._bindEvents();
    }

    _bindEvents() {
        this.button.addEventListener('click', () => {
            this._showTags();
        });

        const allTags = Array.from(this.wrapper.querySelectorAll(this.itemClass));

        allTags.forEach((tag) => {
            tag.addEventListener('click', () => {
                this._bindTags(tag, allTags);
            });
        });
    }

    /**
     * Отображает теги
     */
    _showTags() {
        this.wrapper.classList.toggle(this.activeClass);
        this.button.classList.toggle(this.activeClass);
    }

    /**
     * Навешивает событие нажатия на теги
     * @param {object} tag - нажатый тег
     * @param {array} allTags - массив всех тегов
     */
    _bindTags(tag, allTags) {
        if (this.method === 'string') {
            allTags.forEach((item) => {
                if (item.classList.contains(this.activeClass)) {
                    item.classList.remove(this.activeClass);
                }
            });
        }

        tag.classList.toggle(this.activeClass);
        this._sendRequest(allTags);
    }

    /**
     * отправляет запрос на сервер с выбранными тегами
     * @param {array} tags - массив выбранных тегов или 1 тег.
     */
    _sendRequest(tags) {
        const that = this;
        const filtredTags = tags.filter((tag) => {
            return tag.classList.contains(this.activeClass);
        });

        const tagsData = [];

        if (filtredTags.length) {
            filtredTags.forEach((item) => {
                tagsData.push(item.dataset.tag);
            });
        }

        let yearsData = '';

        if (this.years) {
            const yearsList = document.querySelector(this.years);
            const selectedLine = yearsList.querySelector('.j-years-item.is-active');

            yearsData = selectedLine.dataset.year;
        }

        const formData = this._createFormData(tagsData, yearsData);

        Utils.send(formData, that.url, {
            success(response) {
                const {data} = response;

                that._setTemplate(data.items);

                that._checkMore(data.more);

                Utils.clearHtml(that.contentWrapper);

                that._insertItems(data);
            }
        }, 'POST');
    }

    /**
     * Формирует объект FormData
     * @param {array} tagsData - массив данных
     * @param {array} yearsData - переменная
     * @returns {object} - возвращает сформированный объект FormData
     */
    _createFormData(tagsData, yearsData) {
        const formData = new FormData();

        if (tagsData.length) {
            formData.append('tags', tagsData);
        } else {
            formData.append('tags', []);
        }

        if (yearsData !== '') {
            formData.append('year', yearsData);
        }

        return formData;
    }

    _setTemplate(items = []) {
        const that = this;

        if (items.length === 0) {
            this.template = EmptyTemplate;
        } else if (that.page === 'news') {
            this.template = NewsTemplate;
        }
    }

    _checkMore(more) {
        if (this.moreButton.dataset.page) {
            this.moreButton.dataset.page = 2;
        }

        this.moreButton.style.display = more ? 'inline-flex' : 'none';
    }

    /**
     * Вставляет новые элементы в контейнер
     * @param {object} data - данные для заполнения шаблона
     * @private
     */
    _insertItems(data) {
        this.contentWrapper.insertAdjacentHTML('beforeend', this.template(data));
    }
}

export default Tags;
